<template>
	<ContainerCenter>
		<v-card>
			<v-toolbar
				color="primary"
				dark
				flat
			>
				<v-toolbar-title> Termos de uso </v-toolbar-title>
			</v-toolbar>

			<v-card-text>
				<p> Por favor, revise nossos <LinkDoTermoDeUso /> antes de continuar. </p>
				<v-checkbox
					color="primary"
					label="Aceito os termos de uso"
					:disabled="acoesDesabilitadas"
					v-model="termoAceito"
				/>
			</v-card-text>

			<v-card-actions class="justify-space-between">
				<ModalDeRecusarTermos :onConfirmar="recusarMutate">
					<template #activator="{ on }">
						<v-btn
							text
							color="error"
							:disabled="acoesDesabilitadas"
							:loading="recusando"
							v-on="on"
						>
							Recusar
						</v-btn>
					</template>
				</ModalDeRecusarTermos>

				<v-btn
					text
					@click="aceitarMutate"
					color="primary"
					:disabled="!termoAceito || acoesDesabilitadas"
					:loading="aceitando"
				>
					Prosseguir
				</v-btn>
			</v-card-actions>
		</v-card>
	</ContainerCenter>
</template>

<script setup lang="ts">
import { InputIrmao } from '../../../common/types/Irmao'
import ContainerCenter from '@/components/ui/ContainerCenter.vue'
import { aceitarTermosDeUso, recusarTermosDeUso } from '@/services/AuthService'
import LinkDoTermoDeUso from '@/components/auth/LinkDoTermoDeUso.vue'
import ModalDeRecusarTermos from '@/components/auth/ModalDeRecusarTermos.vue'
import { computed, ref } from 'vue'
import { useRouter } from 'vue2-helpers/vue-router'
import { useMutation } from '@tanstack/vue-query'
import { alert, authModule } from '@/store'

defineProps<{
  usuario: Pick<InputIrmao, 'nomeCompleto' | 'cim'>
}>()

const termoAceito = ref(false)

const router = useRouter()

const { mutate: recusarMutate, isPending: recusando, isSuccess: recusado } = useMutation({
	mutationFn: () => recusarTermosDeUso(),
	async onSuccess() {
		await authModule.logout();
	},
	onError(error) {
		alert.setError(error);
	},
})

const { mutate: aceitarMutate, isPending: aceitando } = useMutation({
	mutationFn: () => aceitarTermosDeUso(),
	async onSuccess(login) {
		await authModule.logarToken(login)
		router.push({ name: 'home' })
			.catch(() => {})
	},
	onError(error) {
		alert.setError(error);
	},
})

const acoesDesabilitadas = computed(() => recusando.value || aceitando.value || recusado.value)

</script>